import React from 'react';
const ContactSection = () => {
  return <section id="contact" className="py-16 px-6 md:px-12 lg:px-24 bg-white" data-id="element-14">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-15">
        <div data-id="element-16">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-17">
            Let's Stay in Touch
          </h2>
        </div>
        <div data-id="element-18">
          <p className="text-lg mb-10" data-id="element-19">
            Have questions, ideas, or simply want to get involved? Reach out
            today and discover how your voice and talents can accelerate
            meaningful change.
          </p>
          <form className="space-y-6" data-id="element-20">
            <div data-id="element-21">
              <label className="block mb-2 font-medium" data-id="element-22">
                Name <span className="text-sm text-gray-500" data-id="element-23">(required)</span>
              </label>
              <div className="grid grid-cols-2 gap-4" data-id="element-24">
                <div data-id="element-25">
                  <input type="text" placeholder="First Name" className="w-full border-b border-gray-300 pb-2 focus:outline-none focus:border-[#c19a3c]" required data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <input type="text" placeholder="Last Name" className="w-full border-b border-gray-300 pb-2 focus:outline-none focus:border-[#c19a3c]" required data-id="element-28" />
                </div>
              </div>
            </div>
            <div data-id="element-29">
              <label className="block mb-2 font-medium" data-id="element-30">
                Email <span className="text-sm text-gray-500" data-id="element-31">(required)</span>
              </label>
              <input type="email" className="w-full border-b border-gray-300 pb-2 focus:outline-none focus:border-[#c19a3c]" required data-id="element-32" />
            </div>
            <div className="flex items-center" data-id="element-33">
              <input type="checkbox" id="newsletter" className="mr-2 h-4 w-4" data-id="element-34" />
              <label htmlFor="newsletter" data-id="element-35">Sign up for news and updates</label>
            </div>
            <div data-id="element-36">
              <label className="block mb-2 font-medium" data-id="element-37">
                Subject{' '}
                <span className="text-sm text-gray-500" data-id="element-38">(required)</span>
              </label>
              <input type="text" className="w-full border-b border-gray-300 pb-2 focus:outline-none focus:border-[#c19a3c]" required data-id="element-39" />
            </div>
            <div data-id="element-40">
              <label className="block mb-2 font-medium" data-id="element-41">
                Message{' '}
                <span className="text-sm text-gray-500" data-id="element-42">(required)</span>
              </label>
              <textarea rows={4} className="w-full border-b border-gray-300 pb-2 focus:outline-none focus:border-[#c19a3c]" required data-id="element-43"></textarea>
            </div>
            <div data-id="element-44">
              <button type="submit" className="bg-black text-white px-10 py-3 rounded-full font-medium hover:bg-opacity-80 transition-all" data-id="element-45">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>;
};
export default ContactSection;